import { Navigate, Route, Routes } from "react-router-dom";
import TodoBoards from "../components/pages/dashboard/todos/TodoBoards";
import { Helmet } from "react-helmet-async";

const Todos = () => {
  return (
    <div className="todos-page">
      <Helmet>
        <title>Tasks | Super User Manager</title>
        <meta
          name="description"
          content="Task boards: organise your team's work with columns, assignees and notes"
        />
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_HOST_URL}/control-panel/todos`}
        />
      </Helmet>
      <Routes>
        <Route index element={<TodoBoards />} />
        <Route path=":boardId" element={<TodoBoards />} />
        <Route path=":boardId/:shortId" element={<TodoBoards />} />
        <Route
          path="*"
          element={<Navigate to="/control-panel/todos" replace />}
        />
      </Routes>
    </div>
  );
};

export default Todos;
